import template from './tsz-report-menu-actions.html';
import './tsz-report-menu-actions.styl';
import actionsTpl from './report-actions-tpl.html';

function controller($state, $scope, $mdDialog, $tszToast, $mdBottomSheet,
  ReportService) {

  'ngInject';

  this.delete = (ev) => {
    $mdBottomSheet.hide();
    ReportService.deleteAction(this.report, ev, () => {
      $scope.$emit('report_deleted', this.report.id);
    });
  };

  this.download = () => {
    $mdBottomSheet.hide();
    ReportService.download(this.report);
  };

  this.export = () => {
    $mdBottomSheet.hide();
    ReportService.export(this.report);
  };

  this.edit = () => {
    $mdBottomSheet.hide('edit');
  };

  this.duplicate = () => {
    $mdBottomSheet.hide();
    ReportService.duplicate(this.report.id)
    .then((response) => {
      $scope.$emit('report_duplicated', response);
    });
  };

  this.openBottomSheet = () => {
    $mdBottomSheet.show({
      template: actionsTpl,
      clickOutsideToClose: true,
      scope: $scope,
      preserveScope: true,
    })

    // Fires when the hide() method is used
   .then((action) => {
     if (action === 'edit') {
       $state.go('report', { id: this.report.id });
     }
   });
  };

}

export default {
  template,
  bindings: {
    report: '<',
  },
  controller,
};



// WEBPACK FOOTER //
// ./src/components/tsz-report-menu-actions/tsz-report-menu-actions.js